'use client';

import Link from 'next/link';
import { ArrowRight, LogOut } from 'lucide-react';
import { useAuth } from '@/hooks/use-auth';
import { useLogout } from '@/hooks/use-logout';
import { Button } from '@/components/ui/button/button';

const DGR_GOLD = '#c5b358';

export function RideAdminPage() {
  const { user, isAuthenticated, eventAdmin, isEventAdmin } = useAuth({ hydrateFromQuery: true });
  const { logout, isLoggingOut } = useLogout();
  const isLoggedInEventAdmin = isEventAdmin() && !!eventAdmin;
  const isLoggedInNonEventAdmin = isAuthenticated && !isLoggedInEventAdmin;

  return (
    <div className="flex min-h-[80vh] items-center justify-center bg-stone-950 p-6">
      <div className="max-w-lg w-full rounded-xl border border-stone-800 bg-stone-900 p-10 text-center">
        <h1 className="text-2xl font-semibold mb-4" style={{ color: DGR_GOLD }}>
          Ride Admin Has Moved
        </h1>

        <div className="space-y-4 text-stone-300 text-sm leading-relaxed">
          <p>
            Ride Admin has been replaced by <strong className="text-white">Event Admin</strong> — a
            single place to manage your ride, your rider profile, and everything else.
          </p>

          <p>
            Your rider profile and event admin can now be on the same email. Simply log in to manage
            your ride.
          </p>
        </div>

        {isLoggedInEventAdmin ? (
          <div className="mt-8 space-y-3">
            <p className="text-white text-sm">
              Welcome back, <strong>{user?.name}</strong>
            </p>
            <Button asChild className="bg-[#c5b358] hover:bg-[#b0a04e] text-stone-950 font-medium">
              <Link href="/event-admin">
                Go to Event Admin
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </div>
        ) : isLoggedInNonEventAdmin ? (
          <div className="mt-8 space-y-3">
            <p className="text-stone-400 text-sm">
              You&apos;re logged in as <strong className="text-white">{user?.name}</strong>, but
              this account doesn&apos;t have event admin access.
            </p>
            <p className="text-stone-400 text-xs">
              Log out and sign in with your event admin email.
            </p>
            <Button
              onClick={() => void logout()}
              disabled={isLoggingOut}
              className="bg-[#c5b358] hover:bg-[#b0a04e] text-stone-950 font-medium"
            >
              <LogOut className="mr-2 h-4 w-4" />
              {isLoggingOut ? 'Logging out...' : 'Log out'}
            </Button>
          </div>
        ) : (
          <div className="mt-8">
            <Button asChild className="bg-[#c5b358] hover:bg-[#b0a04e] text-stone-950 font-medium">
              <Link href="/login">
                Log in to Event Admin
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
